// English
export default {
  MESSAGE: {
    MESSAGE: {
      text: `Relating<br> with quality<br> and building<br> long-term<br> partnerships`,
    },
  },

  LOGIN: {
    LOGIN: {
      title: "Login",
      subtitle: "Go to Tailor Made Tereos",
      //username: "Username",
      inputLogin: "Enter your user",
      loginError: "Please enter a valid user",
      emailError: "Please enter a valid email",
      textPwd: "Password",
      placeUser: "Enter your username",
      placePwd: "Enter your password",
      password: "Forgot your password?",
      button: "Login",
      btnTereos: "Tereos User",
      invalidEmail: "Email not found!",
      invalidUserpwd: "Incorrect username or password!",
      invalidPermissions: "User does not have permission to access the system!",
      error: "Error when processing inputs!",
    },
    FORGOT_PWD: {
      title: "Forgot password",
      subtitle:
        "Please, fill in your e-mail address to receive a link for redefinition",
      placeEmail: "Enter your email",
      password: "Go back to login",
      button: "Send",
      sucess: "Email sent for password reset",
      error: "Error when processing inputs!",
      invalidEMail: "Invalid email!",
      invalidUser: "Invalid User!",
    },
  },

  RESET_PWD:{
    title: "Reset password",
    password: "New password:",
    inputpwd: "Enter a new password",
    verifypwd: "Confirm the password:",
    inputverify: "Enter the password",    
    btnChange: "Change",

    VALIDATION:{
      sucess: "Password reset successfully!",
      required: "The new password field cannot be left blank",
      lenght: "The password must contain at least eight characters",
      unmatchPwd: "Passwords don't match!",
      lowerPwd: "New password must have at least one lower case letter!",
      upperPwd: "New password must have at least one upper case letter!",
      numberPwd: "New password must have at least one number!",
      tokenExp: "Token expired or invalid!",
      tokenError: "Invalid token!",
    },
  },

  HOME: {
    text: `Relationship and information portal <br>
           of Tereos and your company`,
    button: "Login",
  },

  DASHBOARD: {
    title: "Be <br>Welcome<br>",
    subtitle: `This is Tailor Made Tereos,<br>
               our information portal for your company`,
    text1: `Here we will centralize relevant <br>
            information about our relationship,<br>
            such as volume plan, billing,<br>
            order book, logistics and quality.<br>`,
    text2: `Always updated and online, to consult,<br>
            wherever and whenever you want.`,
    text3: `You are accessing our portal first,<br>
            hand, because, as you know,<br>
            we believe in joint construction,<br>
            for long-term partnerships.`,
    text4: `We emphasize that this application is still a<br>
            prototype and will undergo constant updating.<br>
            We count on your suggestions!`,
  },

  DOUBTS: {
    title: "Doubts?<br>",
    text: `For questions, suggestions or
            complaints use one of our
            communication channels below.`,
    phone: "Phone",
    extensions: "extensions:",
  },

  SIDEBAR:{
    HOME:{
      home: "Home",
      userTerms: "Terms of Use",
      changeLanguage: "Change Language",
      exit: "Exit",
      users: "Usuários"
    },
    COMMERCIAL:{
      tittle: "Commercial",
      billingHistory: "Billing History",
      billinDescription: "History of total invoiced volume and average gross price realized in the month",
      volumeRetain: "Volume Retain",
      volumeDescription: `Planning = monthly plan revised and agreed between client and Tereos \n +
      Invoiced = Volume invoiced within the month \n +
      Adherence = Absolute adherence between planned and invoiced within the period.`,
      contractPerformanceESALQ: "Contract Performance ESALQ",
      contractESALQDescription: `Contracted = Volume established in contract\n +
      Invoiced = Volume invoiced in the month \n +
      Adherence = Absolute adherence between contractor and invoiced within the period`,
      contractPerformanceNY: "Contract Performance NY",
      contractNYDescription: `Contracted = Volume established in contract\n +
      Invoiced = Volume invoiced in the month \n +
      Adherence = Absolute adherence between contractor and invoiced within the period`,
      contractPerformanceNYMTM: "Contract Performance NYMTM",
      contractNYMTMDescription: `Fixed = Volume fixed/priced in month \n +
      Invoiced = Volume invoiced with the pricing of the month \n +
      Adherence = Absolute adherence between fixed and invoiced within the period`,
      plannedBilledToBeBilled: "Planned/Billed/ToBeBilled",
      plannedDescription: `Planned = Monthly plan revised and agreed between client and Tereos \n +
      Invoiced = Volume invoiced in the month  \n +
      Orders in Portfolio = Orders in Tereos system that have not yet been invoiced \n +
      Balance/Surplus = Difference between Planned Volume and Sum between Invoiced and Order Portfolio`,
      plannedSubtitle: "- Current Month",
      orderBook: "Order Book",
      orderBookDescription: `"Invoiced = Volume invoiced in the month \n +
      Orders in Portfolio = Orders in Tereos system that have not yet been invoiced`,
      orderSubtitle: "-Current Month",
      billingPerPlant: "Billing Per Plant",
      billingPlantDescription: "Volume invoiced in the current month for each plant",
    },
    FINANCIAL:{
      title: "Financial",
      creditLimit: "Credit Limit",
      credDescription: "Total approved credit utilization status",
      agingList: "Aging List",
      agingDescription: "Amount of securities (NF) outstanding in the month."
   
    },
    LOGISTICS:{
      title: "Logistics",
      noShowDescription: `Nº  of occurrences of NO SHOW per month per Carrier \n
      NO SHOW: No presentation of the driver until 30 minutes before the start of loading (scheduled)`,
      ResidenceDescription: "Average waiting time for loading.",
    },
    QUALITY:{
      title: "Quality",
      complaintPercent: "Complaint Percent",
      percentDescription: "Number of complaints per month and details of the reason for complaints",
      complaintQuantity: "Complaint Quantity",
      quantityDescription: "Number of complaints in the last 12 months, with opening per plant and material",
      complaintSummary: "Complaint Summary",
      summaryDescription: "Number of complaints in the last 12 months, with opening per Tereos unit, reason for complaint and plant",
    },
    FILES: {
      title: 'Files'
    },
    REWARD:{
      title: "Tereos Rewards",
    },
    CONTACT:{
      title: "Contact us",
    },
  },
  

  CHARTS: {

    CONTRACT_ESALQ:{
      volume_traded: "Volume Traded (TON)",
      volume_invoiced: "Volume Invoiced (TON)",
      percentage_ofadh: "% of Adherence",
    },
    CONTRACTO_NY:{
      volume_traded: "Volume Traded (TON)",
      volume_invoiced: "Volume Invoiced (TON)",
      percentage_ofadh: "% of Adherence",

    },
    VOLUME_RETAIN:{
      volume_plan: "Plan Volume (TON)",
      volume_invoiced:  "Volume Invoiced (TON)",
      percentage_ofadh: "% of Adherence",
    },
    CONTRACT_NYMTM:{
      volume_fixed: "Volume Fixed (TON)",
      volume_invoiced:  "Volume Invoiced (TON)",
      percentage_ofadh: "% de Adherence",
    },

      CLUSTERED_BAR:{
        volume_plan: "Plan Volume (TON)",
        volume_fat: "Volume Invoiced (TON)"
      },
      COLUMN_AND_LINE:{
      gross_price: "Gross Price (R$/TON)",
     
      },
      COLUMN_AND_PIE: {
      complaints:  "complaints in",
      amount: "amount",
      cause: "cause",
      },

      DIVERGENT_STACKED:{
      volume_fat: "Volume Invoiced (TON)",
      order_portfolio: "Orders on Backlog.  (TON)",
      balance: "Balance/Surplus amount  (TON)",
      volume_plan: "Volume Plan (TON)",
      },

      AGING_LIST:{
        open_value: "Open Value (R$)"
      },

      EXPORT:{
        export: "Export For",
      },
      ERROR:{
        notfound: "We did not find any information available",
      },

  },

};
